export default "__VITE_ASSET__BA69V8qr__"